import { useEffect, useState } from 'react';
import Loader from './Loader';
import { assets } from '../assets/assets';

const NetworkStatus = ({ onRetry, isLoading }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOnline) {
    return (
      <div className="fixed inset-0 bg-gray-100 flex flex-col items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
          <div className="text-6xl mb-4">🌐</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">No Internet Connection</h2>
          <p className="text-gray-600 mb-6">
            Please check your network connection.
          </p>
          <button 
            onClick={onRetry}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Retry Connection
          </button>
        </div>
        <p className="py-5 text-sm text-center">
          &copy; {new Date().getFullYear()} SAHLA CURTAIN CENTER. All rights
          reserved
        </p>
      </div>
    );
  }

  if (isLoading) {
    return <Loader progress={0} message="Checking network..." />;
  }

  return null;
};

export default NetworkStatus;